import { VERSION, isDate } from "lodash";
import {
  CURRENT_VERSION,
  ENTITY_KEY_PATH,
  ENTITY_NAME_INDEX,
  INDEX_DATE_FORMAT,
  INDEX_DB_ENTITIES_COLUMNS,
  INDEX_DB_NAME,
  INDEX_DB_PRODUCTS_COLUMNS,
  INDEX_DB_STORE_CONFIG,
  INDEX_DB_TABLES,
  PRODUCT_NAME_INDEX
} from '../../constants/IndexDBData'

import ds from "../../Services/DataServices";
import { BEHAVIOUR_TYPE } from "../../Services/DataServices";
import moment from "moment";

export async function initializeIndexedDB () {
  try {
    const db = await openDB(INDEX_DB_NAME, CURRENT_VERSION)
    console.log('INDEX_DB --> Database initialized successfully:', db)
  } catch (error) {
    console.log('INDEX_DB_ERROR --> initializeIndexedDB', error)
  }
}
async function openDB (indexDBName, version) {
  return new Promise((resolve, reject) => {
    const openDBRequest = indexedDB.open(indexDBName, version)

    openDBRequest.onupgradeneeded = event => {
      const db = event.target.result

      INDEX_DB_STORE_CONFIG.forEach(tableConfig => {
        const objectStore = db.createObjectStore(tableConfig.tableName, {
          keyPath: tableConfig.keyPath,
          ...tableConfig.options
        })

        tableConfig.indexes.forEach(indexConfig => {
          objectStore.createIndex(indexConfig.name, indexConfig.keyPath, {
            unique: indexConfig.unique
          })
        })
      })
    }

    openDBRequest.onsuccess = event => {
      const db = event.target.result
      resolve(db)
    }
    openDBRequest.onerror = event => {
      reject('INDEX_DB_ERROR Error opening database: --> openDB', event.target.error)
    }
  })
}
export async function saveEntitiesDatatoIndexBD (
  entitiesData,
  dbName,
  version,
  tableName,
  callFrom
) {
  try {
    const db = await openDB(dbName, version)
    const tx = db.transaction(tableName, 'readwrite')
    const store = tx.objectStore(tableName)
    entitiesData.forEach(async (entityData) => {
      const request = await store.put(entityData);
      request.onsuccess = (event) => {};
      request.onerror = (event) => {
          console.error(`INDEX_DB_ERROR ${tableName} data save error, call from ${callFrom}: --> saveEntitiesDatatoIndexBD`, event.target.error);
      };
      request.onerror = (event) => {
        console.error(`INDEX_DB_ERROR ${tableName} data save error, call from ${callFrom}: --> saveEntitiesDatatoIndexBD`, event.target.error);
      };
      request.onabort = (event) => {
        console.error(`INDEX_DB_ERROR_ABORTED ${tableName} data save abort, call from ${callFrom}: --> saveEntitiesDatatoIndexBD`, event.target.error);
      };
    });

    tx.oncomplete = () => {
      db.close()
    }
  } catch (error) {
    console.error('INDEX_DB_ERROR --> saveEntitiesDatatoIndexBD', error + "tableName : "+ tableName + " callFrom  : " + callFrom )
  }
}
export const saveUpdateEntitiesToIndexedDB = (
  entitiesData,
  keyPath,
  indexDBName,
  indexDBTableName,
  entityNameIndex,
  indexDBEntityColumnName,
  isUnique
) => {
  try {
    const indexedDB =
      window.indexedDB ||
      window.mozIndexedDB ||
      window.webkitIndexedDB ||
      window.msIndexedDB ||
      window.shimIndexedDB

    if (!indexedDB) {
      //console.log("IndexedDB could not be found in this browser.");
    }
    // const request = indexedDB.open(indexDBName, indexDBVersion);
    const request = indexedDB.open(indexDBName)

    request.onerror = function (event) {
      console.error('INDEX_DB_ERROR --> saveUpdateEntitiesToIndexedDB')
      console.error(event)
    }
    request.onupgradeneeded = function () {
      const db = request.result

      const store = db.createObjectStore(indexDBTableName, {
        keyPath: keyPath
      })
      store.createIndex(entityNameIndex, [indexDBEntityColumnName], {
        unique: isUnique
      })
    }

    request.onsuccess = function () {
      //console.log("Database opened successfully");
      const db = request.result

      if (!db.objectStoreNames.contains(indexDBTableName)) {
        console.error(
          `Object store ${indexDBTableName} does not exist in the database.`
        )
        return
      }
      const transaction = db.transaction(indexDBTableName, 'readwrite')
      const store = transaction.objectStore(indexDBTableName)
      entitiesData.forEach(entity => {
        if (entity) {
          store.put(entity)
        }
      })
      transaction.oncomplete = function () {
        db.close()
      }
    }
  } catch (err) {
    console.log('INDEX_DB_ERROR --> saveUpdateEntitiesToIndexedDB', err)
  }
}
export function loadEntitiesSyncDataCount () {
  return dispatch => {
    fetchEntitesSyncData(dispatch)
  }
}
export const GetIndexDBDataByTableName = (dbName, tableName, version) => {
  return new Promise((resolve, reject) => {
    const request = window.indexedDB.open(dbName, version);
    request.onerror = function (event) {
      console.error('INDEX_DB_ERROR --> GetIndexDBDataByTableName' + event.target.errorCode)
      reject(event.target.errorCode)
    }

    request.onsuccess = function (event) {
      const db = event.target.result;
      if (db.objectStoreNames.contains(tableName)) {
        try {
          const transaction = db.transaction([tableName], "readonly");
          const objectStore = transaction.objectStore(tableName);

          const getAllRequest = objectStore.getAll();
          // const getAllRequasdest = objectStore;

          getAllRequest.onsuccess = function (event) {
            const allData = event.target.result;
            resolve(allData);
          };

          getAllRequest.onerror = function (event) {
            console.error("Error retrieving all data: " + event.target.error);
            reject(event.target.error);
          };
        } catch (e) {
            console.log("INDEX_DB_ERROR GetIndexDBDataByTableName : ", tableName);
        }
      } else {
        resolve(false);
      }
    };
  });
};
export async function checkAndSyncData() {
  try {
    const entitiesSyncCounts = await GetIndexDBDataByTableName(
      INDEX_DB_NAME,
      INDEX_DB_TABLES.ENTITIESSYNCCCOUNT,
      CURRENT_VERSION
    );

    if (entitiesSyncCounts) {
      for (const entity of entitiesSyncCounts) {
        const TableName = entity.tableName || "";
        const RowsCount = entity.rowsCount || 0;
        const LastUpdatedOn = entity.lastUpdatedOn || false;
        const timeOutInMinutes = entity ? entity.timeOut : 0;
        const lastSyncedOn = entity ? moment(entity.lastSyncedOn) : null;

        let isSaved = false;
        
        if (entity.isAutoSync) {
          if (!isSaved) {
            const tableData = await GetIndexDBDataByTableName(
              INDEX_DB_NAME,
              TableName,
              CURRENT_VERSION
            );
            const lastTableRowsCount = tableData ? tableData.length : 0;
            const lastUpdatedOn =
              tableData && tableData.length > 0 ? findMaxDate(tableData) : null;
            const isDateChange =
              lastTableRowsCount == RowsCount && lastUpdatedOn != null
                ? true
                : false;
            const currentTime = moment();
            const timeElapsedMinutes = currentTime.diff(
              lastSyncedOn,
              "minutes"
            );
            let timeLimitExceeded = false;
               
            if (timeElapsedMinutes >= timeOutInMinutes) {
              timeLimitExceeded = true;
            } 
            
            if (
              lastTableRowsCount < RowsCount ||
              (isDateChange &&
                LastUpdatedOn &&
                moment(lastUpdatedOn).isBefore(LastUpdatedOn)) ||
              timeLimitExceeded
            ) {

              try {
                const response = await ds.getEntitiesDataByTableName(
                  {
                    TableName: TableName,
                    IndexTableRowsCount: RowsCount,
                    LastTableRowsCount: lastTableRowsCount,
                    IsDateChanged: isDateChange,
                    _LastUpdatedOn:
                      lastUpdatedOn != null
                        ? moment(lastUpdatedOn).format("YYYY-MM-DD HH:mm:ss")
                        : moment().format("YYYY-MM-DD HH:mm:ss"), // is date k bd jo data hy wo mjhe de do api k  keh do
                  },
                  BEHAVIOUR_TYPE.GET
                );

                if (response && response.entitesData.length > 0) {
                  const serverData = response;
                  if (serverData.entitesData[0]) {
                    saveEntitiesDatatoIndexBD(
                      serverData.entitesData[0],
                      INDEX_DB_NAME,
                      CURRENT_VERSION,
                      TableName
                    );
                  }

                  const serverDataOffSet = serverData.indexDataOffSet;
                  const totalPages = Math.ceil(
                    serverData.totalRowsCount / serverDataOffSet
                  );
                  const startPage =
                    lastTableRowsCount !== 0
                      ? Math.floor(lastTableRowsCount / serverDataOffSet)
                      : 2;
                  if (totalPages != 0) {
                    isSaved = await GetTableDataByPageNo(
                      startPage,
                      totalPages,
                      TableName,
                      entity,
                      lastUpdatedOn,
                      isDateChange
                    );
                  }
                }
              } catch (error) {
                console.error(
                  "Error checking and syncing data:",
                  error,
                  entity
                );
              } finally {
                entity.lastSyncedOn = moment().format("YYYY-MM-DD HH:mm:ss");

                updateRecordInIndexedDB(
                  INDEX_DB_NAME,
                  INDEX_DB_TABLES.ENTITIESSYNCCCOUNT,
                  CURRENT_VERSION,
                  entity.tableName,
                  entity
                )
                  .then((message) => {
                    // console.log("salis 1"+message);
                    isSaved = false;
                  })
                  .catch((error) => {
                    // console.log("salis 1"+error);
                    isSaved = false;
                  });

                // Reset the flag after the request is completed (whether success or failure)
              }
            }
          }
        }
      }
    }
  } catch (error) {
    console.error("Error in getting Table Data from IndexedDB:", error);
  }
}
export async function autocompleteSearch(
  dbName,
  tableName,
  version,
  searchKey,
  searchColumns
) {
  let db;
  try {
    const db = await openDB(dbName, version);
    const transaction = db.transaction([tableName], "readonly");
    const store = transaction.objectStore(tableName);

    return new Promise((resolve, reject) => {
      const results = [];
      const request = store.openCursor();

      request.onsuccess = (event) => {
        const cursor = event.target.result;
        if (cursor) {
          const item = cursor.value;
          // Check if any of the specified columns contain the search key
          if (
            searchColumns.some(
              (column) => item[column] && item[column].includes(searchKey)
            )
          ) {
            results.push(item);
          }
          cursor.continue();
        } else {
          resolve(results);
        }
      };

      request.onerror = () => reject(request.error);
    });
  } catch (error) {
    console.error("Error during autocomplete search:", error);
    throw error;
  } finally {
    // Close the connection when done
    if (db) {
      db.close();
    }
  }
}
function findMaxDate(data) {
  let maxDate = moment("0001-01-01T00:00:00");

  data.forEach((item) => {
    const currentDate = moment(item.lastUpdatedOn);
    if (currentDate.isAfter(maxDate)) {
      maxDate = currentDate;
    }
  });

  return maxDate;
}
async function GetTableDataByPageNo(
  startPage,
  totalPages,
  TableName,
  entity,
  lastUpdatedOn
) {
  let pageNo = startPage;
  let isSaved = false;
  let isFetching = false; // Flag to track if a request is in progress

  while (pageNo <= totalPages) {
    if (!isFetching) {
      // Only make the request if not already fetching
      isFetching = true; // Set the flag to indicate that a request is in progress
      let childBody = {
        TableName: TableName,
        IndexTableRowsCount: entity.rowsCount,
        CurrentPageNo: pageNo,
        _LastUpdatedOn:
          lastUpdatedOn != null ? moment(lastUpdatedOn) : moment(),
      };
      try {
        const response = await ds.getEntitiesDataByTableName(childBody);

        if (
          response &&
          response.entitesData &&
          response.entitesData.length > 0
        ) {
          const childServerData = response;
          if (childServerData.entitesData[0]) {
            saveEntitiesDatatoIndexBD(
              childServerData.entitesData[0],
              INDEX_DB_NAME,
              CURRENT_VERSION,
              TableName
            );
          }
          pageNo++;
        } else {
          // Here we end the loop
          break;
        }
      } catch (error) {
        // Handle error here
      } finally {
        isFetching = false; // Reset the flag after the request is completed (whether success or failure)
      }
    }
  }
  if (pageNo > totalPages) {
    isSaved = true;
  }

  return isSaved;
}
async function fetchEntitesSyncData () {
  try {
    const response = await ds.getEntitiesDataSyncCount();

    if (response && response.length > 0) {
      const entitiesData = await GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        INDEX_DB_TABLES.ENTITIESSYNCCCOUNT,
        CURRENT_VERSION
      );

      if (entitiesData && entitiesData.length > 0) {
        const updatedResponse = response.map((responseItem) => {
          const matchingEntity = entitiesData.find(
            (entity) => entity.tableName === responseItem.tableName
          );

          return matchingEntity
            ? { ...responseItem, lastSyncedOn: matchingEntity.lastSyncedOn }
            : responseItem;
        });

        saveEntitiesDatatoIndexBD(
          updatedResponse,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.ENTITIESSYNCCCOUNT
        );
      } else {
        saveEntitiesDatatoIndexBD(
          response,
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.ENTITIESSYNCCCOUNT
        );
      }
    }
  } catch (error) {
    // Handle errors
  }
}
function updateRecordInIndexedDB(dbName, tableName, version, key, updatedData) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, version);

    request.onsuccess = (event) => {
      const db = event.target.result;

      const transaction = db.transaction(tableName, "readwrite");
      const objectStore = transaction.objectStore(tableName);

      const getRequest = objectStore.get(key);

      getRequest.onsuccess = (event) => {
        const record = event.target.result;

        if (record) {
          // Update the record with the provided updatedData.
          for (const prop in updatedData) {
            record[prop] = updatedData[prop];
          }

          const updateRequest = objectStore.put(record);

          updateRequest.onsuccess = () => {
            db.close();
            resolve("Record updated successfully");
          };

          updateRequest.onerror = (error) => {
            db.close();
            reject(`Error updating record: ${error}`);
          };
        } else {
          db.close();
          reject("Record not found");
        }
      };

      transaction.oncomplete = () => {
        db.close();
      };
    };

    request.onerror = (event) => {
      reject(`Error opening database: ${event.target.error}`);
    };
  });
}
export async function removeEntitiesDatatoIndexBD (
  entitiesData,
  dbName,
  version,
  tableName
) {
  try {
    const db = await openDB(dbName, version)
    const tx = db.transaction(tableName, 'readwrite')
    const store = tx.objectStore(tableName)

    entitiesData.forEach(entityData => {
      const request = store.delete(entityData.indexKey)
      request.onsuccess = event => {
        console.log(
          `${tableName} data removed successfully:`,
          event.target.result
        )
      }
      request.onerror = event => {
        console.error(
          `INDEX_DB_ERROR ${tableName} removeEntitiesDatatoIndexBD`,
          event.target.error
        )
      }
    })

    tx.oncomplete = () => {
      db.close()
    }
  } catch (error) {
    console.error('INDEX_DB_ERROR Error removeEntitiesDatatoIndexBD:', error)
  }
}